import { render, staticRenderFns } from "./DeviceCard.vue?vue&type=template&id=48c83af8"
import script from "./DeviceCard.vue?vue&type=script&lang=js"
export * from "./DeviceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports